const setRRConfigSearch = skuIds => {
	const searchItems = skuIds?.slice(0, 14);

	if (window?.RR_CONFIG?.search) {
		window.RR_CONFIG.search = {
			terms: window?.od?.algoliaSearchQuery,
			items: searchItems,
		};

		window?.od?.events?.publish('RR_CONFIG_data_available');
	}
};

export default setRRConfigSearch;
